export default __webpack_public_path__ + "dff90cc150338a3810e40d71402256c6.svg";